module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, [(_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.L.localize(_vm.label)))]) : _vm._e(), _vm._v(" "), _c('progress', {
    staticClass: "progress__bar",
    attrs: {
      "max": _vm.maxProgress
    },
    domProps: {
      "value": _vm.currentProgress
    }
  }), _vm._v(" "), (_vm.showValues) ? _c('span', {
    staticClass: "progress__indication"
  }, [_vm._v(_vm._s(_vm.shownValue))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4d5b806a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/partials/ProgressBar.vue
// module id = 732
// module chunks = 1